module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path class="st0" d="M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24 24-10.7 24-24S37.3 0 24 0m10 18.6v.7c0 7.5-5.3 16.1-15 16.1-3 0-5.8-1-8.1-2.6.5.1.9.1 1.3.1 2.4 0 4.7-.9 6.5-2.4-2.3 0-4.2-1.6-4.9-3.9.3.1.7.1 1 .1.5 0 1-.1 1.4-.2-2.4-.6-4.2-2.9-4.2-5.6v-.1c.7.4 1.5.7 2.4.7-1.4-1-2.3-2.7-2.3-4.7 0-1.1.2-2.1.7-2.9 2.6 3.4 6.5 5.7 10.9 5.9-.1-.4-.1-.9-.1-1.3 0-3.2 2.4-5.7 5.3-5.7 1.5 0 2.8.7 3.8 1.8 1.3-.3 2.4-.8 3.4-1.4-.4 1.3-1.2 2.4-2.3 3.1 1-.1 2.1-.4 3-.9-.7 1.2-1.6 2.2-2.8 3.2"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/tw.svg
// module id = 118
// module chunks = 1